import React from "react";
import { Icon } from "@iconify/react";
import BildupIcon from "../assets/images/bild-loader.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-purple-200   text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center border-b border-t border-purple-500 py-4">
          {/* Logo and brand section */}
          <div className="mb-4 md:mb-0 ">
            <a href="/" className="flex items-center">
              <img src={BildupIcon} alt="Bildup" className="h-10 " />
            </a>
          </div>

          {/* Social media icons */}
          <div className="flex space-x-4 mb-4 md:mb-0">
            <a
            target = "blank"
              href="https://www.facebook.com/bildupai/"
              className="text-white hover:text-gray-200"
              aria-label="Facebook"
            >
              <Icon icon="mdi:facebook" className="w-5 h-5" />
            </a>
            <a
            target = "blank"
              href="http://www.youtube.com/@BildupAI"
              className="text-white hover:text-gray-200"
              aria-label="YouTube"
            >
              <Icon icon="mdi:youtube" className="w-5 h-5" />
            </a>
            <a
            target = "blank"
              href="https://www.tiktok.com/@bildupai"
              className="text-white hover:text-gray-200"
              aria-label="TikTok"
            >
              <Icon icon="ic:baseline-tiktok" className="w-5 h-5" />
            </a>
            <a
            target = "blank"
              href="https://www.linkedin.com/company/bildupai/"
              className="text-white hover:text-gray-200"
              aria-label="LinkedIn"
            >
              <Icon icon="mdi:linkedin" className="w-5 h-5" />
            </a>
            <a
            target = "blank"
              href="https://www.instagram.com/bildupai/"
              className="text-white hover:text-gray-200"
              aria-label="Instagram"
            >
              <Icon icon="mdi:instagram" className="w-5 h-5" />
            </a>
            <a
            target = "blank"
              href="https://x.com/@BildupAi"
              className="text-white hover:text-gray-200"
              aria-label="Twitter"
            >
              <Icon icon="mdi:twitter" className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Footer info row */}
        <div className=" pt-4   text-sm text-center md:text-left">
          <div className="flex flex-col   justify-between items-start text-[18px] md:w-[20%] md:ml-auto">
            <div className="flex flex-col gap-1 items-start border-b w-full pb-4 mb-3 border-purple-500">
              <a href="/#" className="text-white ">
                Home
              </a>

              <a href="/early-adopters" className="text-white ">
                Early Adopters
              </a>
            </div>
            <div className="mb-2 md:mb-0 text-[16px]">
              <p>© {currentYear} Bildup. All rights reserved.</p>
            </div>

            {/* <div className="flex space-x-4 text-[16px]">
              <a href="/privacy" className="text-white hover:underline">
                Privacy
              </a>
              <span className="text-purple-300">•</span>
              <a href="/terms" className="text-white hover:underline">
                Terms
              </a>
            </div> */}

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
